var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',{staticClass:"glitch",attrs:{"data-text":"Season 13"}},[_vm._v("Season 13")]),_vm._l((_vm.episodes),function(ep,id){return _c('EpisodeCollection',{key:id,attrs:{"episode":ep,"id":id}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }